import {Button, Col, Flex, Form, Input, Row, Space, Spin} from 'antd';
import {useState, useEffect, useMemo, useRef} from "react";
import _ from 'lodash-es';
import request from "../../../libs/request";
import Evisit from "../../../libs/Evisit";
import intl from "react-intl-universal";

async function postSMSAlert(visitId, phone) {
    return request.post(`${window.base_url}/api_v3/visits/${visitId}/sms_alert`, {phone});
}

const PhoneCallbackConfirmation = ({data, isMobileWebview, endWorkflow}) => {
    const patientSelectedPhone = _.get(data, "search_for_patient.value.phone") || _.get(data, "create_patient.value.phone");
    const formRef = useRef();
    const [formReady, setFormReady] = useState(false);
    const [loading, setLoading] = useState(false);

    const {visitId} = useMemo(() => ({
        visitId: _.get(data, "visit.value.id"),
    }), [data]);

    const displayVisitId = useMemo(() => {
        return Evisit.getDisplayVisitId(_.get(data, "visit.value"));
    }, [data]);

    /**
     * @async handleOnSubmit
     * @returns {Promise<void>}
     */
    async function handleOnSubmit(data) {
        setLoading(true);
        const resp = await postSMSAlert(visitId, data.mobile_number).finally(() => {
            setLoading(false)
        });
        if (resp) {
            _.set(data, "visit.value.type", 0);
            endWorkflow();
        }
    }

    /**
     *
     * @param changedValues
     */
    function handleOnValuesChange(changedValues) {
        setFormReady(Evisit.validatePhoneNumber(_.get(changedValues, "mobile_number")));
    }

    /**
     *
     * @returns {*}
     */
    function handleOnCloseModal() {
        return formRef?.current?.submit();
    }

    useEffect(() => {
        const form = formRef?.current;
        form?.validateFields();
        if (Evisit.validatePhoneNumber(form?.getFieldValue("mobile_number"))) {
            setFormReady(true)
        }
    }, []);

    return (
        <Space direction="vertical" size="middle" style={{display: 'flex'}}>
            <div>
                <br/>
                Your callback request is submitted successfully. The provider will call you back soon at the following
                number.
                <br/>
                <br/>
                {intl.get("encounter_id").d("Encounter ID")}: {displayVisitId}
                <br/>
                <br/>
                <Form
                    initialValues={{
                        "mobile_number": patientSelectedPhone
                    }}
                    ref={formRef}
                    wrapperCol={{span: 12}}
                    onFinish={handleOnSubmit}
                    onValuesChange={handleOnValuesChange}
                >
                    <Form.Item
                        label={`${intl.get("mobile_number").d("Mobile number")}:`}
                        name="mobile_number"
                        validateTrigger="onChange"
                        rules={[
                            {
                                required: true,
                                message: intl.get("mobile_number_is_required").d("Mobile number is required"),
                            },
                            {
                                validator: (_, value) => {
                                    if (!value) {
                                        return Promise.resolve();
                                    }
                                    if (Evisit.validatePhoneNumber(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(intl.get("invalid_mobile_number").d("Invalid mobile number")));
                                },
                            },
                        ]}
                        className={"ant-formio-form-item"}
                    >
                        <Input/>
                    </Form.Item>
                </Form>
                <br/>
                <br/>
            </div>
            <Flex justify={isMobileWebview ? "center" : "flex-end"} gap="small">
                <Button
                    type={"primary"}
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    disabled={!formReady}
                    onClick={handleOnCloseModal}
                    loading={loading}
                >
                    {intl.get('close').d('Close')}
                </Button>
            </Flex>
        </Space>
    );
}

export default PhoneCallbackConfirmation;